import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { botTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const ADD_BOT_PAGE_TOAST = 'add-bot-page';

export const addBotPage: botTypes.AddPage = (data) => {
  return axios.put('/bot/pages', data);
};

type AddBotPageOptions = {
  config?: MutationConfig<typeof addBotPage>;
};

export function useAddBotPage({ config = {} }: AddBotPageOptions) {
  return useMutation({
    ...config,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['bot-pages']);
      toasts.loadingToast.success(ADD_BOT_PAGE_TOAST, 'Page added successfully');
      config.onSuccess?.(...args);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error(ADD_BOT_PAGE_TOAST, serverMessage);
      config.onError?.(error, variables, context);
    },
    onMutate: (variables) => {
      toasts.loadingToast.loading(ADD_BOT_PAGE_TOAST, 'Adding page...');
      return config.onMutate?.(variables);
    },
    mutationFn: addBotPage,
  });
}
